export default __webpack_public_path__ + "static/media/20.8a14acc0.jpg";